import './style.scss'
import { useContext, useState } from "react";
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import { AbsoluteContainer, AppSpan, AppText, CenterPopup, CenterPopupContainer, FlexColumn } from "src/style"
import { VscChromeClose } from "react-icons/vsc";
import utility from 'src/utils/utility';

export const Responder: React.FC<any> = () => {
    const { visibility: {response}, responder } = useContext(VisibilityContext)
    const [isHover, setIsHover] = useState(false)

    const responderIcon = utility.getResponderIcon(response.type)

    function closeResponder () {
        responder.hide()
    }
    
    return (
        <CenterPopupContainer>
            <CenterPopup data-aos="zoom-in">
                <AbsoluteContainer top="2" right="2.5">
                    <VscChromeClose 
                        fontSize='1.6rem' color={isHover ? '#EB5757' : '#000000'}
                        onMouseEnter={() => setIsHover(true)}
                        onMouseLeave={() => setIsHover(false)}
                        onClick={closeResponder}
                    />
                </AbsoluteContainer>
                <FlexColumn 
                    justifyContent="center" width="32.2"
                    className="responder-content-container"
                >
                    {responderIcon}
                    <AppText 
                        textSize="1.6" color="#181D27" 
                        fontWeight="700" align='center'
                        topMargin="1"
                    >
                        {response.title}
                    </AppText>
                    <AppSpan color="#6E7985" align="center">
                        {response.message}
                    </AppSpan>
                </FlexColumn>
            </CenterPopup>
        </CenterPopupContainer>
    )
}